module.exports = __webpack_public_path__ + "img/phone-illustration.bfa9f35c.svg";